/**
 * Chooses a random component value from an array of component values
 * @param values - Array of component values to choose from
 * @returns A random component value
 */
export const chooseRandomComponentValue = (values: string[]): string => {
  if (values.length === 0) {
    return "";
  }
  return values[Math.floor(Math.random() * values.length)];
};
